<template>
  <section class="min-h-screen venue-ui:bg-surface-base venue-ui:text-fg-primary text-fg-g-primary">
    <MessageAlert id="venue-version-alert" :show="hasVenueAppVersionChanged">
      There's a new version of Turntable available.
      <a id="refresh-button" class="text-fg-link-primary cursor-pointer" @click="refresh">
        Refresh to get the latest.
      </a>
    </MessageAlert>
    <HeaderComponent v-show="!isCheckoutDesktopFlow" />
    <div
      class="w-full"
      :class="[isCheckoutDesktopFlow ? 'flex justify-between items-start' : 'px-4 lg:px-16 py-4']"
    >
      <StatusBar v-show="!isCheckoutDesktopFlow" />
      <router-view :class="isCheckoutDesktopFlow ? 'py-16 px-12 w-full shrink-[20]' : ''" />
      <CheckoutDesktopDetailSidebar v-if="isCheckoutDesktopFlow" />
    </div>
  </section>
</template>

<script lang="ts">
import { breakpointsTailwind, useBreakpoints, useEventBus, useWebSocket } from '@vueuse/core'
import { mapStores } from 'pinia'
import { defineComponent } from 'vue'

import { guestKey, onVenueMessage } from '@/api/events'
import MessageAlert from '@/common/components/molecules/MessageAlert.vue'
import CheckoutDesktopDetailSidebar from '@/components/CheckoutDesktopDetailSidebar.vue'
import HeaderComponent from '@/components/HeaderComponent.vue'
import { usePerformanceReservationStore } from '@/modules/performance/stores/PerformanceReservationStore'
import StatusBar from '@/pages/guest/StatusBar.vue'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'
import loc from '@/utils/loc'

export default defineComponent({
  name: 'AppVenue',
  components: {
    CheckoutDesktopDetailSidebar,
    MessageAlert,
    HeaderComponent,
    StatusBar,
  },

  computed: {
    ...mapStores(useSettingStore, useCheckoutStore),
    hasVenueAppVersionChanged(): boolean {
      return this.settingStore.hasVenueAppVersionChanged
    },
    isLargeScreen(): boolean {
      return useBreakpoints(breakpointsTailwind).lg.value
    },
    isCheckoutDesktopFlow(): boolean {
      return (
        this.checkoutStore.performance !== null &&
        this.isLargeScreen &&
        this.$route.name !== 'setShow' &&
        this.$route.name !== 'showDetails' &&
        this.$route.name !== 'calendar' &&
        this.$route.name !== 'order-details' &&
        !this.$route.path.startsWith('/venue')
      )
    },
  },
  setup() {
    useWebSocket(`wss://${window.location.host}/ws/`, {
      autoReconnect: {
        retries: 5,
        delay: 1000,
      },
      onMessage: onVenueMessage,
    })
    useEventBus(guestKey).on(usePerformanceReservationStore().onGuestChange)
  },
  methods: {
    refresh() {
      loc.reload()
    },
  },
  watch: {
    '$route.path'(value: string) {
      if (value.startsWith('/venue')) {
        this.checkoutStore.performance = null
      }
    },
    isCheckoutDesktopFlow: {
      immediate: true,
      handler(value: boolean) {
        this.checkoutStore.setIsDesktopFlow(value)
      },
    },
  },
})
</script>
